import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface SelectionCompleteEvent<R> {
    result: R;
  }

@Directive()
export abstract class BaseSelectable<R> {
    formGroup: FormGroup;
    errorMessage: string;
    @Input()
    errorCode: string;
    @Output()
    validSelection = new EventEmitter<SelectionCompleteEvent<R>>();
    constructor() {}
}
